import React from "react"
import styled from "styled-components"
import { AppFunctionComponent } from "../../../../types"
import { TooltipBox, TooltipText } from "../tooltip.component"

const Text = styled(TooltipText)`
  &:first-of-type {
    font-weight: 500;
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.tablet - 1}px) {
    &:first-of-type {
      font-weight: 500;
      font-size: ${18 / 16}rem;
    }
  }
  @media (min-width: ${({ theme }) => theme.breakpoint.tablet}px) {
    font-size: ${12 / 16}rem;
    line-height: ${17.5 / 12}em;
  }
  @media (min-width: ${({ theme }) => theme.breakpoint.desktop}px) {
    font-size: ${14 / 16}rem;
    line-height: ${24 / 14}em;
  }
`

const Container = styled(TooltipBox)`
  min-height: 170px;
  padding: 14px;

  @media (min-width: ${({ theme }) => theme.breakpoint.tablet}px) {
    min-height: auto;
    max-width: 222px;
  }
  @media (min-width: ${({ theme }) => theme.breakpoint.desktop}px) {
    max-width: 288px;
    padding: 20px;
  }
`

export interface TooltipProps {
  title: string
  text: string
}

const Tooltip: AppFunctionComponent<TooltipProps> = ({
  className,
  title,
  text,
}) => {
  return (
    <Container className={className}>
      <Text>{title}</Text>
      <Text>{text}</Text>
    </Container>
  )
}

export default Tooltip
